import React from 'react'
import {useTranslation} from "react-i18next"

import {IonButton, IonButtons, IonIcon, IonItem, IonItemOptions, IonLabel} from "@ionic/react"
import {colorWandOutline, colorWandSharp} from "ionicons/icons";

import {TimeLimit as ItemType}     from "../../types/TimeLimit"
import IconTimeLimit               from "../common/Icons/TimeLimit"

import ListItemButtonData          from "./ListItem/ButtonData";
import ListItemButtonKeyTimeLimit  from "./ListItem/ButtonKeyTimeLimit";
import ListItemButtonLockTimeLimit from "./ListItem/ButtonLockTimeLimit";
import ListItemOptionDelete        from "./ListItem/OptionDelete";

interface itemProps {
    item: ItemType
}

const ListItem: React.FC<itemProps> = ({ item }) => {

    const {t} = useTranslation(), minButtonWidth: string = '50px'

    return (
        <>
            <IonItem button detail routerLink={"/time-limits/" + item.id + '/view'} slot="start">
                <IconTimeLimit slot="start" />
                <IonLabel>
                    <h2>
                        {item.name}
                    </h2>
                    <h3 style={{ 'color': "#777" }}>
                        {item.description}
                    </h3>
                    {(item.startDate || item.endDate) &&
                    <h4 className="ion-hide-sm-down" style={{ 'fontWeight': 400, 'fontSize': '0.75rem', 'lineHeight': 1.4 }}>
                        {item.startDate && <span>{t('common.from')}: {item.startDate}</span>}
                        {(item.startDate && item.endDate) && <br />}
                        {item.endDate && <span>{t('common.until')}: {item.endDate}</span>}
                    </h4>
                    }
                </IonLabel>
                <IonButtons className="ion-hide-sm-down" slot="end">
                    {item.isDynamic == true &&
                    <span style={{ 'minWidth': minButtonWidth }}>
                        <IonButton color="medium" fill="clear" size="large" style={{ 'fontSize': '1rem' }}>
                            <IonIcon slot="icon-only" ios={colorWandOutline} md={colorWandSharp} />
                        </IonButton>
                    </span>
                    }
                    <span style={{ 'minWidth': minButtonWidth }}>
                        <ListItemButtonKeyTimeLimit timeLimit={item} />
                    </span>
                    <span style={{ 'minWidth': minButtonWidth }}>
                        <ListItemButtonLockTimeLimit timeLimit={item} />
                    </span>
                    <span style={{ 'minWidth': minButtonWidth }}>
                        <ListItemButtonData timeLimit={item} />
                    </span>
                </IonButtons>
            </IonItem>
            <IonItemOptions slot="end">
                {item.options?.isDeletable && <ListItemOptionDelete item={item} />}
            </IonItemOptions>
        </>
    )
}

export default ListItem